import {
  IconSparkles,
  Inspector,
  IndigoIndigo50,
  Box
} from '@sequencehq/core-components'
import { Chat } from './components/Chat'

interface RevenueWaterfallInspectorProps {
  revenueWaterfallData?: any
  revenueWaterfallFilters?: any
  currency?: string
}

export const RevenueWaterfallInspector = ({
  revenueWaterfallData,
  revenueWaterfallFilters,
  currency,
  expanded,
  showItemId
}: RevenueWaterfallInspectorProps & {
  expanded?: boolean
  showItemId?: string
} = {}) => {
  return (
    <Inspector expanded={expanded} showItemId={showItemId}>
      <Inspector.ItemGroup>
        <Inspector.IconItem
          id="revenueWaterfall.ai"
          data-testid="contract-extraction.inspector.item"
          tooltip="AI"
          content={
            <Box width="600px" height="100%" p={0}>
              <Chat
                revenueWaterfallData={revenueWaterfallData}
                revenueWaterfallFilters={revenueWaterfallFilters}
                currency={currency}
              />
            </Box>
          }
          icon={<IconSparkles color={IndigoIndigo50} />}
        />
      </Inspector.ItemGroup>
    </Inspector>
  )
}
